<template>

<app-wrapper>

	<app-text>

		<h2>{{ page.customer_profile_contact_contact }}</h2>

		<app-group>

			<app-input-text :label="page.customer_profile_contact_phone_label" v-model="inputs.phone" :errored="errored.phone" :placeholder="page.customer_profile_contact_phone_placeholder" />
			<app-input-text :label="page.customer_profile_contact_email_label" v-model="inputs.email" :errored="errored.email" :placeholder="page.customer_profile_contact_email_placeholder" />

		</app-group>

		<h2>{{ page.customer_profile_contact_address }}</h2>

		<app-group>

			<app-input-text :label="page.customer_profile_contact_address_1_label" v-model="inputs.address_1" :errored="errored.address_1" :placeholder="page.customer_profile_contact_address_1_placeholder" />
			<app-input-text :label="page.customer_profile_contact_address_2_label" v-model="inputs.address_2" :errored="errored.address_2" :placeholder="page.customer_profile_contact_address_2_placeholder" />
			<app-input-text :label="page.customer_profile_contact_address_city_label" v-model="inputs.address_city" :errored="errored.address_city" :placeholder="page.customer_profile_contact_address_city_placeholder" />
			<app-input-select :label="page.customer_profile_contact_address_county_label" :options="data.counties" v-model="inputs.address_county" :errored="errored.address_county" :placeholder="page.customer_profile_contact_address_county_placeholder" />
			<app-input-text :label="page.customer_profile_contact_address_postcode_label" v-model="inputs.address_postcode" :errored="errored.address_postcode" :placeholder="page.customer_profile_contact_address_postcode_placeholder" />

		</app-group>

		<app-group :row="true" :center="true">

			<app-button text="Save changes" :success="is.saved" :fail="is.errored" :disabled="!is.valid" :loading="is.submitting" v-on:click="onSaveClick" />

		</app-group>

	</app-text>

</app-wrapper>

</template>

<script>

import mixinForm from '@/mixin/form.js'

export default {

	mixins: [mixinForm],

	data: function() {

		return {
			stayAfterSave: true,
			inputs: {
				email: '',
				phone: '',
				address_1: '',
				address_2: '',
				address_city: '',
				address_county: '',
				address_postcode: ''
			},
			rules: {
				email: {
					required: true
				},
				phone: {
					required: true
				},
				address_county: {
					required: true
				}
			}
		}

	},

	methods: {

		resetValues: function() {

			this.inputs.phone = this.session.phone
			this.inputs.email = this.session.email
			this.inputs.address_1 = this.session.address.street
			this.inputs.address_2 = this.session.address.locality
			this.inputs.address_city = this.session.address.city
			this.inputs.address_county = this.session.address.county
			this.inputs.address_postcode = this.session.address.postcode
		},

		onSaveClick: function() {

			this.save('account/profile/contact', this.inputs)

		}

	}

}

</script>